import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Redirects to /profile if the authenticated customer's company profile is
 * incomplete, passing `profileIncomplete: true` in router state so the
 * Profile page can display the amber notice banner.
 *
 * Drop this call at the top of any page that requires a complete profile
 * (e.g. Products, NewOrder).
 */
const useRequireCompleteProfile = () => {
  const { profile } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (profile && (profile.company?.company_profile_complete === false || profile.company_profile_complete === false)) {
      navigate('/profile', { replace: true, state: { profileIncomplete: true } });
    }
  }, [profile, navigate]);
};

export default useRequireCompleteProfile;
